import React from 'react';
import { StyledSvg, iconGenerator } from '../Icon';
const BudgetCancelledIcon = ({ size, deg, }) => (React.createElement(StyledSvg, { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 20 20", size: size, deg: deg },
    React.createElement("rect", { width: "14", height: "14", x: "3", y: "3", fill: "#7A8499", fillRule: "evenodd", rx: "7" })));
export const BudgetCancelled = iconGenerator(BudgetCancelledIcon);
//# sourceMappingURL=BudgetCancelled.js.map